interface ClassesDescriptorType {
  [key: string]: boolean | undefined;
}

export default (descriptor: ClassesDescriptorType): string => (
  Object.entries(descriptor).reduce(
    (result, [key, value]) => {
      if (value) {
        return `${result} ${key.trim()}`;
      }
      return result;
    },
    '',
  ).trim()
);
